import React from "react";
import { getAccessSettings } from "../../Shared/Utility";

type ColumnVisibilityProps = {
  columnVisibilityViewObject: any;
  addNewRecord: Function;
  showHideVisibilityList: Function;
  showHideChangeHandler: Function;
};

function ColumnVisibilityView(props: ColumnVisibilityProps) {
  return (
    <div className="flex-items">
      {getAccessSettings(2, 24) > 1 &&    <a className="btn-primary" onClick={() => props.addNewRecord()}>
        <img src="images/add.svg" width="16px" height="15px" alt="Add" />
      </a>}
      <div className="view-list">
        <a
          className="btn-primary"
          onClick={() => props.showHideVisibilityList()}
        >
          <img src="images/eye.svg" width="16px" height="15px" alt="Eye" />
        </a>

        {props.columnVisibilityViewObject.ShowHide && (
          <div className="check-list check-list-admin">
            {props.columnVisibilityViewObject.ColumnNames.map(
              (ColumnNames: any, index: any) => {
                if (ColumnNames.ActualColumnName !== "HasFK") {
                  return (
                    <div key={index} className="check-item">
                      <input
                        className="check-form"
                        type="checkbox"
                        name={ColumnNames.ActualColumnName}
                        value={ColumnNames.IsVisible}
                        checked={ColumnNames.IsVisible}
                        onChange={(e) => props.showHideChangeHandler(e)}
                      />
                      <span>{ColumnNames.Name} </span>
                    </div>
                  );
                }
              }
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ColumnVisibilityView;
